/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard example components

// Functions from store
import { ArcElement, Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import MDBox from "components/MDBox";
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";
import { Doughnut } from "react-chartjs-2";
import Cookies from "universal-cookie";
import { getWarehouseEfficiencyReportHome } from "../../store";

const cookies = new Cookies();

const WarehouseEfficiancyCard = ({
  getWarehouseEfficiencyReportHome,
  getWarehouseEfficiencyReportHomeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;
  let jwtToken = loginDetails?.jwt;
  const [warehouseEfficiencyData, setWarehouseEfficiencyData] = useState([]);
  const [warehouseEfficiencyPieChartData, setWarehouseEfficiencyPieChartData] =
    useState("");

  useEffect(() => {
    getWarehouseEfficiencyReportHome(jwtToken);
  }, []);

  useEffect(() => {
    const dataObj =
      getWarehouseEfficiencyReportHomeReducer?.warehouseEfficiency?.data;

    setWarehouseEfficiencyData(dataObj);

    const pieData = dataObj?.pieChartData || [];
    setWarehouseEfficiencyPieChartData(pieData);
  }, [getWarehouseEfficiencyReportHomeReducer]);

  const filledPercentage = (
    (warehouseEfficiencyData?.totalNonEmptyLocationCount /
      warehouseEfficiencyData?.totalLocationCount) *
    100
  ).toFixed(2);

  const emptyPercentage = (
    (warehouseEfficiencyData?.totalEmptyLocationCount /
      warehouseEfficiencyData?.totalLocationCount) *
    100
  ).toFixed(2);

  const filledPercentageWithSuffix = `${filledPercentage}%`;
  const emptyPercentageWithSuffix = `${emptyPercentage}%`;

  const pieData = {
    labels: ["Empty", "Occupied"],
    datasets: [
      {
        data: [
          warehouseEfficiencyData?.totalEmptyLocationCount,
          warehouseEfficiencyData?.totalNonEmptyLocationCount,
        ],
        backgroundColor: ["#28b463", "#e74c3c"],
        hoverOffset: 2,
      },
    ],
  };

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: "#FF0000",
        formatter: (value, context) => {
          console.log("Test Data Index:", context.dataIndex);
          console.log("Test Value:", value);
          const staticLabels = [55, 10, 30, 5];
          return staticLabels[context.dataIndex];
        },
        anchor: "center",
        align: "center",
        font: {
          weight: "bold",
          size: 16,
        },
      },
      // tooltip: {
      //   callbacks: {
      //     label: function (context) {
      //       const label = context.label || "";
      //       const value = context.parsed;
      //       const total = context.dataset.data.reduce(
      //         (sum, current) => sum + current,
      //         0
      //       );
      //       const percentage = ((value / total) * 100).toFixed(2);
      //       return `${label}: ${value} (${percentage}%)`;
      //     },
      //   },
      // },
    },
  };

  // Register Chart.js plugins
  Chart.register(ArcElement);
  Chart.register(ChartDataLabels);

  // Custom datalabels formatter to show percentage
  const pieOptions = {
    plugins: {
      datalabels: {
        display: true,
        color: "#fff",
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((sum, v) => sum + v, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage}%`;
        },
        anchor: "center",
        align: "center",
        font: {
          weight: "bold",
          size: 18,
        },
        backgroundColor: (context) => {
          return context.dataset.backgroundColor[context.dataIndex];
        },
        borderRadius: 8,
        padding: 6,
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          color: "#344767",
          font: {
            size: 16,
            weight: "bold",
          },
          boxWidth: 20,
          padding: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.parsed;
            const total = context.dataset.data.reduce(
              (sum, current) => sum + current,
              0,
            );
            const percentage = ((value / total) * 100).toFixed(2);
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
    cutout: "70%",
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <MDBox style={{ height: "355px", width: "98.5%", marginLeft: "6px" }}>
      <SimpleBlogCard
        style={{ marginTop: "10px" }}
        title="Warehouse Efficiency"
        description={
          <>
            {/* <MDBox
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
            > */}
            {/* Left side - Pie chart */}
            <div
              style={{
                // width: "500px",
                height: "220px",
                // background:
                //   "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)",
                borderRadius: "50%",
                // boxShadow: "0 4px 24px rgba(52, 71, 103, 0.12)",
                display: "flex",
                alignItems: "left",
                justifyContent: "left",
                marginTop: "20px",
              }}
            >
              <Doughnut
                data={pieData}
                options={pieOptions}
                plugins={[ChartDataLabels]}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "0.5rem",
              }}
            >
              <h5>
                <span style={{ color: "#344767" }}>Total:</span>{" "}
                {warehouseEfficiencyData?.totalLocationCount}
              </h5>
              <h5>
                <span style={{ color: "#28b463" }}>Empty:</span>{" "}
                {warehouseEfficiencyData?.totalEmptyLocationCount}
              </h5>
              <h5>
                <span style={{ color: "#e74c3c" }}>Occupied:</span>{" "}
                {warehouseEfficiencyData?.totalNonEmptyLocationCount}
              </h5>
            </div>
            {/* </MDBox> */}
          </>
        }
      />
    </MDBox>
  );
};

const mapStateToProps = (state) => {
  return {
    getWarehouseEfficiencyReportHomeReducer:
      state.getWarehouseEfficiencyReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWarehouseEfficiencyReportHome: (jwtToken) =>
      dispatch(getWarehouseEfficiencyReportHome(jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WarehouseEfficiancyCard);
